import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { images } from '../../constants';

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const GitHubIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.009-.868-.013-1.703-2.782.604-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0 1 12 6.836a9.59 9.59 0 0 1 2.504.337c1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.202 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.741 0 .267.18.579.688.481C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);

const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const navItems = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const modalVariants = {
  hidden: { y: '-100%', opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] },
  },
  exit: {
    y: '-100%',
    opacity: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

const navItemVariants = {
  hidden: { opacity: 0, x: 40 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: 0.3 + i * 0.09, duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

const leftPanelVariants = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { delay: 0.25, duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

const GoldDivider = () => (
  <div className="relative z-10 flex items-center">
    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-rose-500/40 to-transparent" />
  </div>
);

const NavModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="nav-modal"
          variants={modalVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="fixed inset-0 z-[60] flex flex-col overflow-hidden"
        >
          {/* ── Background image ── */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.bgmodal})` }}
          />

          {/* ── Dark cinematic overlay ── */}
          <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(4,6,12,0.96)_0%,rgba(4,6,12,0.88)_35%,rgba(4,6,12,0.75)_65%,rgba(4,6,12,0.65)_100%)]" />

          {/* ── Warm gold atmospheric glow ── */}
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_75%_25%,rgba(244,63,94,0.10)_0%,transparent_55%)]" />
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_20%_80%,rgba(251,146,60,0.06)_0%,transparent_50%)]" />

          {/* ── TOP BAR ── */}
          <div className="relative z-10 flex items-center justify-between px-5 py-4 sm:px-8 lg:px-12">
            <button
              type="button"
              onClick={onClose}
              aria-label="Close menu"
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white/8 text-white ring-1 ring-white/15 transition duration-300 hover:bg-white/15 hover:ring-white/30"
            >
              <CloseIcon />
            </button>

            <p className="hidden text-[10px] font-bold uppercase tracking-[0.28em] text-rose-400/90 sm:block">
              From Concept to Code
              <span className="mx-2 text-white/30">·</span>
              <span className="text-white/50">Engineering Solutions That Scale</span>
            </p>

            <a
              href="#projects"
              onClick={onClose}
              className="inline-flex items-center justify-center rounded-full bg-rose-500 px-5 py-2 text-xs font-semibold text-white shadow-lg shadow-rose-500/30 transition hover:bg-rose-400"
            >
              View Projects
            </a>
          </div>

          {/* ── TOP GOLD DIVIDER ── */}
          <GoldDivider />

          {/* ── BODY ── */}
          <div className="relative z-10 flex flex-1 overflow-hidden">

            {/* ── LEFT PANEL ── */}
            <motion.div
              variants={leftPanelVariants}
              initial="hidden"
              animate="visible"
              className="flex w-full flex-col justify-between px-6 py-8 sm:w-[45%] sm:px-10 lg:px-14 xl:px-16"
            >
              <div className="flex flex-col gap-6">
                {/* Gold accent line */}
                <div className="flex items-center gap-3">
                  <span className="h-px w-8 bg-rose-400/60" />
                  <span className="text-[9px] font-bold uppercase tracking-[0.3em] text-rose-400/60">
                    Software Engineer
                  </span>
                </div>

                {/* Signature logo */}
                <div>
                  <img
                    src={images.collinslogo1}
                    alt="Collins Musoko"
                    className="h-auto w-44 object-contain sm:w-52 lg:w-60 xl:w-64"
                  />
                </div>

                {/* Bio stats */}
                <div className="space-y-4">
                  <div className="border-l-2 border-rose-400/20 pl-4">
                    <p className="text-[8px] font-semibold uppercase tracking-[0.22em] text-white/30">
                      Architecting systems since
                    </p>
                    <p className="mt-0.5 text-sm font-bold uppercase tracking-wider text-white/85">
                      Bootcamp to Production
                    </p>
                  </div>
                  <div className="border-l-2 border-rose-400/20 pl-4">
                    <p className="text-[8px] font-semibold uppercase tracking-[0.22em] text-white/30">
                      Specialising in
                    </p>
                    <p className="mt-0.5 text-sm font-bold uppercase tracking-wider text-white/85">
                      Full-Stack Web Platforms
                    </p>
                  </div>
                  <div className="border-l-2 border-rose-400/20 pl-4">
                    <p className="text-[8px] font-semibold uppercase tracking-[0.22em] text-white/30">
                      Stack follows the problem
                    </p>
                    <p className="mt-0.5 text-sm font-bold uppercase tracking-wider text-white/85">
                      Node · Python · React · Next
                    </p>
                  </div>
                </div>
              </div>

              {/* Bottom tagline */}
              <div className="mt-8 sm:mt-0">
                <div className="mb-3 h-px w-full bg-gradient-to-r from-rose-400/20 to-transparent" />
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/85">
                  I don&apos;t just write code
                </p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.15em] text-rose-400/65">
                  I own the problem — and ship the solution.
                </p>
              </div>
            </motion.div>

            {/* ── Vertical divider — desktop ── */}
            <div className="my-6 hidden w-px bg-gradient-to-b from-transparent via-rose-500/25 to-transparent sm:block" />

            {/* ── RIGHT PANEL — nav links ── */}
            <div className="hidden flex-1 flex-col justify-center gap-0 px-10 sm:flex lg:px-16 xl:px-20">
              {navItems.map((item, i) => (
                <motion.a
                  key={item.label}
                  href={item.href}
                  custom={i}
                  variants={navItemVariants}
                  initial="hidden"
                  animate="visible"
                  onClick={onClose}
                  className="group flex items-center gap-5 border-b border-white/5 py-4 text-3xl font-light text-white/45 transition duration-300 last:border-b-0 hover:text-white lg:py-5 lg:text-4xl xl:text-5xl"
                >
                  <span className="h-px w-0 shrink-0 bg-rose-400/80 transition-all duration-500 group-hover:w-10" />
                  <span className="transition-transform duration-300 group-hover:translate-x-1">
                    {item.label}
                  </span>
                  <span className="ml-auto text-[10px] font-bold uppercase tracking-widest text-white/0 transition duration-300 group-hover:text-rose-400/50">
                    0
                    {i + 1}
                  </span>
                </motion.a>
              ))}
            </div>

            {/* ── Mobile nav links ── */}
            <div className="absolute bottom-8 left-6 right-6 flex flex-col gap-0 sm:hidden">
              {navItems.map((item, i) => (
                <motion.a
                  key={item.label}
                  href={item.href}
                  custom={i}
                  variants={navItemVariants}
                  initial="hidden"
                  animate="visible"
                  onClick={onClose}
                  className="group flex items-center gap-3 border-b border-white/5 py-3 text-xl font-light text-white/55 transition hover:text-white"
                >
                  <span className="h-px w-0 bg-rose-400/70 transition-all duration-300 group-hover:w-5" />
                  {item.label}
                  <span className="ml-auto text-[9px] font-bold uppercase tracking-widest text-white/0 transition group-hover:text-rose-400/50">
                    0
                    {i + 1}
                  </span>
                </motion.a>
              ))}
            </div>
          </div>

          {/* ── BOTTOM GOLD DIVIDER ── */}
          <GoldDivider />

          {/* ── FOOTER ── */}
          <div className="relative z-10 flex flex-wrap items-center justify-between gap-3 px-5 py-3 sm:px-8 lg:px-12">

            {/* Email */}
            <a
              href="mailto:mussocollins@gmail.com"
              className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-widest text-white/40 transition hover:text-white/80"
            >
              <EmailIcon />
              <span className="hidden sm:inline">mussocollins@gmail.com</span>
              <span className="sm:hidden">Email</span>
            </a>

            {/* Social icons */}
            <div className="flex items-center gap-3">
              <a
                href="https://github.com/Carshy"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/8 text-white/55 ring-1 ring-white/12 transition duration-300 hover:bg-rose-400/15 hover:text-rose-300 hover:ring-rose-400/40"
              >
                <GitHubIcon />
              </a>
              <a
                href="https://www.linkedin.com/in/collins-musoko/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/8 text-white/55 ring-1 ring-white/12 transition duration-300 hover:bg-rose-400/15 hover:text-rose-300 hover:ring-rose-400/40"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://wa.me/254717684174"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white/8 text-white/55 ring-1 ring-white/12 transition duration-300 hover:bg-emerald-400/15 hover:text-emerald-300 hover:ring-emerald-400/40"
              >
                <WhatsAppIcon />
              </a>
            </div>

            {/* Available for hire */}
            <div className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
              </span>
              <span className="text-[10px] font-medium uppercase tracking-widest text-white/40">
                Available for hire
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

NavModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NavModal;
